import React from 'react';
import './HomePage.css';

const WhyChooseUs = () => {
  const features = [
    {
      id: 1,
      icon: '💎',
      title: 'Ethically Sourced',
      description: 'Our diamonds are 100% conflict-free, ensuring ethical practices from mine to market.',
      color: '#00f3ff', // Neon Blue
    },
    {
      id: 2,
      icon: '✨',
      title: 'Exquisite Craftsmanship',
      description: 'Each piece is handcrafted by master artisans with precision and care.',
      color: '#7d3cff', // Stellar Purple
    },
    {
      id: 4,
      icon: '🚚',
      title: 'Global Shipping',
      description: 'Fast and secure shipping to all over India.',
      color: '#00ff88', // Neon Green
    },
    {
      id: 6,
      icon: '🌟',
      title: 'Custom Designs',
      description: 'Create your own unique piece with our custom design service.',
      color: '#ff6b6b', // Neon Pink
    },
  ];

  return (
    <section className="why-choose-us">
      <div className="parallax-background"></div>
      <h2 className="section-title">Why Choose Us</h2>
      <p className="section-subtitle">
        Discover what makes NM Diamond the ultimate choice for luxury jewelry.
      </p>
      <div className="choose-container">
        <div className="features-grid">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="feature-card"
              style={{ '--hover-color': feature.color }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
              <div className="hover-effect"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;